import { render, staticRenderFns } from "./DrilldownsTab.vue?vue&type=template&id=0704fcca"
import script from "./DrilldownsTab.vue?vue&type=script&lang=js"
export * from "./DrilldownsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports